export default __webpack_public_path__ + "static/floorplan-3d-7f316d10653e16d777ec6c6d95cf600e.png";